// import React, { useEffect, useState } from "react";
// import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { 
//   Box, 
//   Button, 
//   IconButton, 
//   Menu, 
//   MenuItem, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   DialogActions, 
//   TextField,
//   Typography,
//   Chip,
//   CircularProgress,
//   Paper,
//   FormControl,
//   InputLabel,
//   Select,
//   Grid,
//   InputAdornment,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Tooltip,
//   Avatar,
//   Badge,
//   Snackbar,
//   Container,
//   Divider
// } from "@mui/material";
// import MuiAlert from '@mui/material/Alert';
// import { 
//   Search as SearchIcon,
//   FilterList as FilterListIcon,
//   MoreVert as MoreVertIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Info as InfoIcon,
//   Refresh as RefreshIcon,
//   Clear as ClearIcon,
//   Download as DownloadIcon,
//   PictureAsPdf as PdfIcon,
//   InsertDriveFile as FileIcon,
//   Visibility as ViewIcon,
//   Person as PersonIcon,
//   CalendarToday as CalendarIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Save as SaveIcon
// } from "@mui/icons-material";

// // Simple Alert component - remove forwardRef if causing issues
// const Alert = MuiAlert;

// // OR use this simpler version
// // const Alert = (props) => <MuiAlert elevation={6} variant="filled" {...props} />;

// // EditableTableCell component for inline editing - Exactly like investorActivity
// const EditableTableCell = ({ record, field, value, isEditing, onFieldChange, fieldType = "text" }) => {
//   if (isEditing) {
//     // For date fields
//     if (fieldType === "date") {
//       return (
//         <TableCell>
//           <TextField
//             size="small"
//             type="date"
//             value={value ? new Date(value).toISOString().split('T')[0] : ''}
//             onChange={(e) => onFieldChange(field, e.target.value)}
//             InputLabelProps={{ shrink: true }}
//             sx={{ width: '100%' }}
//           />
//         </TableCell>
//       );
//     }
    
//     // For numeric fields
//     if (fieldType === "number") {
//       return (
//         <TableCell>
//           <TextField
//             size="small"
//             type="number"
//             value={value || 0}
//             onChange={(e) => onFieldChange(field, parseInt(e.target.value) || 0)}
//             sx={{ width: '80px' }}
//             inputProps={{ min: 0 }}
//           />
//         </TableCell>
//       );
//     }
    
//     // For text fields
//     if (fieldType === "text") {
//       return (
//         <TableCell>
//           <TextField
//             size="small"
//             value={value || ''}
//             onChange={(e) => onFieldChange(field, e.target.value)}
//             sx={{ width: '100%' }}
//             multiline={field === "description" || field === "notes"}
//             rows={field === "description" || field === "notes" ? 2 : 1}
//           />
//         </TableCell>
//       );
//     }
    
//     // For status field (select)
//     if (fieldType === "status") {
//       return (
//         <TableCell>
//           <Select
//             size="small"
//             value={value || 'pending'}
//             onChange={(e) => onFieldChange(field, e.target.value)}
//             sx={{ width: '120px' }}
//           >
//             <MenuItem value="pending">Pending</MenuItem>
//             <MenuItem value="verified">Approved</MenuItem>
//             <MenuItem value="declined">Declined</MenuItem>
//             <MenuItem value="requested">Requested</MenuItem>
//           </Select>
//         </TableCell>
//       );
//     }
    
//     // Default to regular cell for non-editable fields
//     return <TableCell>{value}</TableCell>;
//   }
  
//   // Non-editable mode - display values
//   if (fieldType === "date" && value) {
//     return <TableCell>{new Date(value).toLocaleDateString()}</TableCell>;
//   }
  
//   if (fieldType === "number") {
//     return <TableCell>{value || 0}</TableCell>;
//   }
  
//   return <TableCell>{value || ''}</TableCell>;
// };

// export default function ApproveHandover() {
//   // Main states
//   const [handoverData, setHandoverData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // Search and filter states - Like investorActivity
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);
  
//   // Status filter states
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  
//   // Row selection and action states
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  
//   // Dialog states
//   const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
//   const [declineDialogOpen, setDeclineDialogOpen] = useState(false);
//   const [requestDialogOpen, setRequestDialogOpen] = useState(false);
//   const [viewDialogOpen, setViewDialogOpen] = useState(false);
//   const [remarks, setRemarks] = useState("");
  
//   // Processing states
//   const [isProcessing, setIsProcessing] = useState(false);
  
//   // Inline editing states - Exactly like investorActivity
//   const [editingId, setEditingId] = useState(null);
//   const [editedRowData, setEditedRowData] = useState(null);
//   const [originalRowData, setOriginalRowData] = useState(null);
  
//   // Pagination states - Exactly like investorActivity
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);
  
//   // Toast Notification States - Using MUI Snackbar like investorActivity
//   const [toastOpen, setToastOpen] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");
//   const [toastSeverity, setToastSeverity] = useState("success");

//   // Toast Notification Functions - Like investorActivity
//   const showToast = (message, severity = "success") => {
//     setToastMessage(message);
//     setToastSeverity(severity);
//     setToastOpen(true);
//   };

//   const handleToastClose = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setToastOpen(false);
//   };

//   const showSuccessToast = (message) => {
//     showToast(message, "success");
//   };

//   const showErrorToast = (message) => {
//     showToast(message, "error");
//   };

//   const showWarningToast = (message) => {
//     showToast(message, "warning");
//   };

//   const showInfoToast = (message) => {
//     showToast(message, "info");
//   };

//   // Get status color - FIXED: Use only valid MUI colors
//   const getStatusColor = (status) => {
//     switch(status.toLowerCase()) {
//       case "approved": return "success";
//       case "declined": return "error";
//       case "pending": return "warning";
//       case "requested": return "info";
//       default: return "default";
//     }
//   };

//   // Get chip color - FIXED: Map to valid MUI colors
//   const getChipColor = (status) => {
//     switch(status.toLowerCase()) {
//       case "approved": return "success";
//       case "declined": return "error";
//       case "pending": return "warning";
//       case "requested": return "info";
//       default: return "default";
//     }
//   };

//   // Fetch handover data
//   const fetchHandoverData = async () => {
//     setLoading(true);
//     try {
//       const response = await GetDataFromApiWithParams("/parks/handover");
      
//       if (response && Array.isArray(response)) {
//         console.log("Handover data fetched:", response);
        
//         // Format dates for display
//         const formattedData = response.map((item, index) => ({
//           ...item,
//           no: index + 1, // Add sequential number like investorActivity
//           date_of_handover_formatted: item.date_of_handover 
//             ? new Date(item.date_of_handover).toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: 'short',
//                 day: 'numeric'
//               })
//             : "N/A",
//           original_date_of_handover: item.date_of_handover,
//           status: item.status || "pending"
//         }));
        
//         setHandoverData(formattedData);
//         setSearchResults(formattedData);
//         setTotalRecords(formattedData.length);
        
//         showSuccessToast("Handover records loaded successfully!");
//       } else {
//         setHandoverData([]);
//         setSearchResults([]);
//         setTotalRecords(0);
//         showInfoToast("No handover records found");
//       }
//     } catch (error) {
//       console.error("Error fetching handover data:", error);
//       setHandoverData([]);
//       setSearchResults([]);
//       setTotalRecords(0);
//       showErrorToast("Failed to load handover records");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchHandoverData();
//   }, []);

//   // Search function for edit tab - Like investorActivity
//   const handleSearch = async () => {
//     try {
//       setIsSearching(true);
      
//       const searchValue = searchQuery.toLowerCase().trim();
      
//       if (!searchValue) {
//         // If search is empty, show all records with status filter
//         let filtered = [...handoverData];
//         if (statusFilter !== "all") {
//           filtered = filtered.filter(item => 
//             (item.status || "pending").toLowerCase() === statusFilter.toLowerCase()
//           );
//         }
//         setSearchResults(filtered);
//         setTotalRecords(filtered.length);
//         setPage(0);
//         showInfoToast(`Showing ${filtered.length} records`);
//         return;
//       }
      
//       // Search across all records
//       const filtered = handoverData.filter(item => {
//         if (statusFilter !== "all" && (item.status || "pending").toLowerCase() !== statusFilter.toLowerCase()) {
//           return false;
//         }
        
//         // Search in multiple fields like investorActivity
//         return (
//           (item.id && item.id.toString().toLowerCase().includes(searchValue)) ||
//           (item.agreement_id && item.agreement_id.toLowerCase().includes(searchValue)) ||
//           (item.handed_over_to && item.handed_over_to.toLowerCase().includes(searchValue)) ||
//           (item.handed_over_by && item.handed_over_by.toLowerCase().includes(searchValue)) ||
//           (item.notes && item.notes.toLowerCase().includes(searchValue)) ||
//           (item.park_id && item.park_id.toLowerCase().includes(searchValue))
//         );
//       });
      
//       setSearchResults(filtered);
//       setTotalRecords(filtered.length);
//       setPage(0);
      
//       const resultCount = filtered.length;
//       if (resultCount > 0) {
//         showSuccessToast(`Found ${resultCount} handover records!`);
//       } else {
//         showWarningToast("No records found for your search.");
//       }
//     } catch (error) {
//       console.error("Error searching activities:", error);
//       setSearchResults([]);
//       setTotalRecords(0);
//       showErrorToast("Search failed! Please try again.");
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   // Handle enter key in search - Like investorActivity
//   const handleSearchKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSearch();
//     }
//   };

//   // Apply status filters
//   const applyStatusFilter = (status) => {
//     setStatusFilter(status);
//     let filtered = [...handoverData];
    
//     if (status !== "all") {
//       filtered = filtered.filter(item => 
//         (item.status || "pending").toLowerCase() === status.toLowerCase()
//       );
//     }
    
//     // Also apply search query if exists
//     if (searchQuery.trim()) {
//       const searchValue = searchQuery.toLowerCase().trim();
//       filtered = filtered.filter(item => 
//         (item.id && item.id.toString().toLowerCase().includes(searchValue)) ||
//         (item.agreement_id && item.agreement_id.toLowerCase().includes(searchValue)) ||
//         (item.handed_over_to && item.handed_over_to.toLowerCase().includes(searchValue)) ||
//         (item.handed_over_by && item.handed_over_by.toLowerCase().includes(searchValue)) ||
//         (item.notes && item.notes.toLowerCase().includes(searchValue)) ||
//         (item.park_id && item.park_id.toLowerCase().includes(searchValue))
//       );
//     }
    
//     setSearchResults(filtered);
//     setTotalRecords(filtered.length);
//     setPage(0);
//     setFilterAnchorEl(null);
//   };

//   // Clear all filters
//   const handleClearFilters = () => {
//     setSearchQuery("");
//     setStatusFilter("all");
//     setSearchResults(handoverData);
//     setTotalRecords(handoverData.length);
//     setPage(0);
//     showInfoToast("All filters cleared");
//   };

//   // Start inline editing - Like investorActivity
//   const handleInlineEdit = (record) => {
//     // If we're already editing a different row, cancel that edit first
//     if (editingId && editingId !== record.id) {
//       handleCancelInlineEdit();
//     }
    
//     setEditingId(record.id);
//     setOriginalRowData({...record});
//     setEditedRowData({...record});
    
//     showInfoToast(`Editing record #${record.id}. Click save to save changes or cancel to discard.`);
//   };

//   // Save inline edits
//   const handleSaveInlineEdit = async () => {
//     if (!editedRowData) return;
    
//     try {
//       setIsProcessing(true);
//       showInfoToast("Saving changes...");
      
//       // Prepare the data for update
//       const updateData = {
//         ...editedRowData,
//         date_of_handover: editedRowData.original_date_of_handover || editedRowData.date_of_handover,
//         // Remove formatted fields
//         date_of_handover_formatted: undefined,
//         no: undefined // Remove sequential number
//       };
      
//       console.log("Sending data to update:", updateData);
      
//       // Simulate API call
//       await new Promise(resolve => setTimeout(resolve, 1000));
      
//       // Update local state
//       setHandoverData(prevData =>
//         prevData.map(item =>
//           item.id === editingId
//             ? { 
//                 ...updateData,
//                 date_of_handover_formatted: updateData.date_of_handover 
//                   ? new Date(updateData.date_of_handover).toLocaleDateString('en-US', {
//                       year: 'numeric',
//                       month: 'short',
//                       day: 'numeric'
//                     })
//                   : "N/A",
//                 no: item.no // Keep the sequential number
//               }
//             : item
//         )
//       );
      
//       // Update search results
//       setSearchResults(prevResults => 
//         prevResults.map(item =>
//           item.id === editingId
//             ? { 
//                 ...updateData,
//                 date_of_handover_formatted: updateData.date_of_handover 
//                   ? new Date(updateData.date_of_handover).toLocaleDateString('en-US', {
//                       year: 'numeric',
//                       month: 'short',
//                       day: 'numeric'
//                     })
//                   : "N/A",
//                 no: item.no
//               }
//             : item
//         )
//       );
      
//       // Exit edit mode
//       setEditingId(null);
//       setEditedRowData(null);
//       setOriginalRowData(null);
      
//       showSuccessToast("Record updated successfully!");
//     } catch (error) {
//       console.error("Error saving record:", error);
//       showErrorToast("Failed to save changes!");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // Cancel inline editing
//   const handleCancelInlineEdit = () => {
//     setEditingId(null);
//     setEditedRowData(null);
//     setOriginalRowData(null);
//     showInfoToast("Edit cancelled");
//   };

//   // Handle field changes in inline editing
//   const handleFieldChange = (fieldName, value) => {
//     setEditedRowData(prev => ({
//       ...prev,
//       [fieldName]: value
//     }));
//   };

//   // Delete record - Like investorActivity
//   const handleDeleteRecord = async (recordId) => {
//     if (window.confirm("Are you sure you want to delete this handover record?")) {
//       try {
//         setIsProcessing(true);
//         showInfoToast("Deleting handover record...");
        
//         // Simulate API call
//         await new Promise(resolve => setTimeout(resolve, 1000));
        
//         // Update local state
//         setHandoverData(prevData => prevData.filter(item => item.id !== recordId));
//         setSearchResults(prevData => prevData.filter(item => item.id !== recordId));
//         setTotalRecords(prev => prev - 1);
        
//         // If we're deleting the record that's being edited, cancel edit mode
//         if (editingId === recordId) {
//           setEditingId(null);
//           setEditedRowData(null);
//           setOriginalRowData(null);
//         }
        
//         showSuccessToast("Handover record deleted successfully!");
//       } catch (error) {
//         console.error("Error deleting record:", error);
//         showErrorToast("Failed to delete handover record!");
//       } finally {
//         setIsProcessing(false);
//       }
//     }
//   };

//   // View record details - Like investorActivity
//   const handleViewRecord = (record) => {
//     setSelectedRow(record);
//     setViewDialogOpen(true);
//     showInfoToast(`Viewing details for record #${record.id}`);
//   };

//   const handleCloseViewDialog = () => {
//     setViewDialogOpen(false);
//     setSelectedRow(null);
//   };

//   // Action menu handlers
//   const handleActionMenuOpen = (event, row) => {
//     setActionMenuAnchorEl(event.currentTarget);
//     setSelectedRow(row);
//   };

//   const handleActionMenuClose = () => {
//     setActionMenuAnchorEl(null);
//     setSelectedRow(null);
//   };

//   // Action handlers for MoreVert menu
//   const handleApproveClick = () => {
//     setApprovalDialogOpen(true);
//     handleActionMenuClose();
//   };

//   const handleDeclineClick = () => {
//     setDeclineDialogOpen(true);
//     handleActionMenuClose();
//   };

//   const handleRequestClick = () => {
//     setRequestDialogOpen(true);
//     handleActionMenuClose();
//   };

//   const handleViewDetails = (row) => {
//     handleViewRecord(row);
//     handleActionMenuClose();
//   };

//   // API call to update status
//   const updateHandoverStatus = async (handoverId, newStatus, remarks = "") => {
//     setIsProcessing(true);
//     try {
//       // Simulate API call
//       await new Promise(resolve => setTimeout(resolve, 1000));
      
//       // Update local state
//       setHandoverData(prevData =>
//         prevData.map(item =>
//           item.id === handoverId
//             ? { 
//                 ...item, 
//                 status: newStatus,
//                 remarks: remarks || item.remarks
//               }
//             : item
//         )
//       );
      
//       // Update search results
//       setSearchResults(prevResults => 
//         prevResults.map(item =>
//           item.id === handoverId
//             ? { 
//                 ...item, 
//                 status: newStatus,
//                 remarks: remarks || item.remarks
//               }
//             : item
//         )
//       );
      
//       showSuccessToast(`Handover ${newStatus} successfully!`);
//       return true;
//     } catch (error) {
//       console.error("Error updating status:", error);
//       showErrorToast(`Failed to ${newStatus} handover`);
//       return false;
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // Dialog handlers
//   const handleVerifyConfirm = async () => {
//     if (!selectedRow) return;
    
//     const success = await updateHandoverStatus(selectedRow.id, "approved", remarks);
//     if (success) {
//       setApprovalDialogOpen(false);
//       setRemarks("");
//     }
//   };

//   const handleDeclineConfirm = async () => {
//     if (!selectedRow) return;
    
//     const success = await updateHandoverStatus(selectedRow.id, "declined", remarks);
//     if (success) {
//       setDeclineDialogOpen(false);
//       setRemarks("");
//     }
//   };

//   const handleRequestConfirm = async () => {
//     if (!selectedRow) return;
    
//     const success = await updateHandoverStatus(selectedRow.id, "requested", remarks);
//     if (success) {
//       setRequestDialogOpen(false);
//       setRemarks("");
//     }
//   };

//   // Handle pagination - Like investorActivity
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Refresh activities list - Like investorActivity
//   const handleRefreshActivities = () => {
//     fetchHandoverData();
//     showInfoToast("Refreshing handover records...");
//   };

//   // Calculate paginated data
//   const paginatedData = searchResults.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   return (
//     <Container>
//       {/* Toast Notification - Fixed Alert usage */}
//       <Snackbar 
//         open={toastOpen} 
//         autoHideDuration={6000} 
//         onClose={handleToastClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//       >
//         <Alert 
//           onClose={handleToastClose} 
//           severity={toastSeverity}
//           sx={{ width: '100%' }}
//         >
//           {toastMessage}
//         </Alert>
//       </Snackbar>

//       {/* Main Title - Like investorActivity */}
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h5" gutterBottom fontWeight="bold">
//           Handover Approvals
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Review and verified handover records
//         </Typography>
//       </Box>
          
//       {/* Search Section - Exactly like investorActivity */}
//       <Paper sx={{ p: 2, mb: 3 }}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="Search by ID, Agreement ID, Handover To, Notes, etc."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               onKeyPress={handleSearchKeyPress}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} />,
//               }}
//               variant="outlined"
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <Button
//               fullWidth
//               variant="contained"
//               onClick={handleSearch}
//               disabled={isSearching || loading}
//               startIcon={<SearchIcon />}
//             >
//               {isSearching ? 'Searching...' : 'Search'}
//             </Button>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <Button
//               fullWidth
//               variant="outlined"
//               onClick={handleRefreshActivities}
//               startIcon={<RefreshIcon />}
//               disabled={loading}
//             >
//               Refresh
//             </Button>
//           </Grid>
//         </Grid>
        
//         {/* Filter chips and status - Similar to investorActivity */}
//         <Box sx={{ mt: 2, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
//           <Button
//             size="small"
//             startIcon={<FilterListIcon />}
//             onClick={(e) => setFilterAnchorEl(e.currentTarget)}
//             variant={statusFilter !== "all" ? "contained" : "outlined"}
//             color="primary"
//           >
//             Status Filter
//           </Button>
          
//           {statusFilter !== "all" && (
//             <Chip
//               label={`Status: ${statusFilter}`}
//               onDelete={() => applyStatusFilter("all")}
//               size="small"
//               color="primary"
//             />
//           )}
          
//           {(searchQuery || statusFilter !== "all") && (
//             <Button
//               size="small"
//               startIcon={<ClearIcon />}
//               onClick={handleClearFilters}
//               variant="outlined"
//             >
//               Clear Filters
//             </Button>
//           )}
//         </Box>
//       </Paper>

//       {/* Status filter menu - Similar to investorActivity */}
//       <Menu
//         anchorEl={filterAnchorEl}
//         open={Boolean(filterAnchorEl)}
//         onClose={() => setFilterAnchorEl(null)}
//       >
//         <MenuItem onClick={() => applyStatusFilter("all")}>
//           All Status
//         </MenuItem>
//         <MenuItem onClick={() => applyStatusFilter("pending")}>
//           <Chip label="PENDING" color="warning" size="small" sx={{ mr: 1 }} />
//           Pending
//         </MenuItem>
//         <MenuItem onClick={() => applyStatusFilter("verfy")}>
//           <Chip label="VERIFIED" color="success" size="small" sx={{ mr: 1 }} />
//           Approved
//         </MenuItem>
//         <MenuItem onClick={() => applyStatusFilter("declined")}>
//           <Chip label="DECLINED" color="error" size="small" sx={{ mr: 1 }} />
//           Declined
//         </MenuItem>
//         <MenuItem onClick={() => applyStatusFilter("requested")}>
//           <Chip label="REQUESTED" color="info" size="small" sx={{ mr: 1 }} />
//           Requested
//         </MenuItem>
//       </Menu>

//       {/* Action menu */}
//       <Menu
//         anchorEl={actionMenuAnchorEl}
//         open={Boolean(actionMenuAnchorEl)}
//         onClose={handleActionMenuClose}
//       >
//         <MenuItem onClick={() => handleViewDetails(selectedRow)}>
//           <ViewIcon sx={{ mr: 1, fontSize: 20 }} />
//           View Details
//         </MenuItem>
//         <MenuItem onClick={handleApproveClick} disabled={selectedRow?.status === "verified"}>
//           <CheckCircleIcon sx={{ mr: 1, fontSize: 20, color: 'success.main' }} />
//           Verify
//         </MenuItem>
//         <MenuItem onClick={handleDeclineClick} disabled={selectedRow?.status === "declined"}>
//           <CancelIcon sx={{ mr: 1, fontSize: 20, color: 'error.main' }} />
//           Decline
//         </MenuItem>
        
//       </Menu>

//       {/* Results Section - Exactly like investorActivity */}
//       <Paper sx={{ width: '100%', overflow: 'hidden', mb: 3 }}>
//         <TableContainer sx={{ maxHeight: 600 }}>
//           <Table stickyHeader size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell>No</TableCell>
//                 <TableCell>ID</TableCell>
//                 <TableCell>Agreement ID</TableCell>
//                 <TableCell>Handed Over To</TableCell>
//                 <TableCell>Handed Over By</TableCell>
//                 <TableCell>Handover Date</TableCell>
//                 <TableCell>Notes</TableCell>
//                 <TableCell>Park ID</TableCell>
//                 <TableCell>Status</TableCell>
//                 <TableCell align="center">Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={10} align="center">
//                     <CircularProgress size={24} />
//                     <Typography variant="body2" sx={{ mt: 1 }}>
//                       Loading handover records...
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : searchResults.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={10} align="center">
//                     <Typography variant="body2" color="textSecondary">
//                       {searchQuery || statusFilter !== "all" 
//                         ? 'No records found for your search criteria. Try a different search term.' 
//                         : 'No handover records found. Start by registering handovers.'}
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 paginatedData.map((record) => (
//                   <TableRow 
//                     key={record.id} 
//                     hover
//                     sx={{ 
//                       backgroundColor: editingId === record.id ? 'action.selected' : 'inherit',
//                       '&:hover': {
//                         backgroundColor: editingId === record.id ? 'action.selected' : 'action.hover'
//                       }
//                     }}
//                   >
//                     <TableCell>{record.no}</TableCell>
//                     <TableCell>{record.id}</TableCell>
                    
//                     {/* Editable cells - Using the same pattern as investorActivity */}
//                     <EditableTableCell
//                       record={record}
//                       field="agreement_id"
//                       value={editingId === record.id ? editedRowData?.agreement_id : record.agreement_id}
//                       isEditing={editingId === record.id}
//                       onFieldChange={handleFieldChange}
//                       fieldType="text"
//                     />
                    
//                     <EditableTableCell
//                       record={record}
//                       field="handed_over_to"
//                       value={editingId === record.id ? editedRowData?.handed_over_to : record.handed_over_to}
//                       isEditing={editingId === record.id}
//                       onFieldChange={handleFieldChange}
//                       fieldType="text"
//                     />
                    
//                     <EditableTableCell
//                       record={record}
//                       field="handed_over_by"
//                       value={editingId === record.id ? editedRowData?.handed_over_by : record.handed_over_by}
//                       isEditing={editingId === record.id}
//                       onFieldChange={handleFieldChange}
//                       fieldType="text"
//                     />
                    
//                     <EditableTableCell
//                       record={record}
//                       field="date_of_handover"
//                       value={editingId === record.id ? editedRowData?.original_date_of_handover : record.original_date_of_handover}
//                       isEditing={editingId === record.id}
//                       onFieldChange={handleFieldChange}
//                       fieldType="date"
//                     />
                    
//                     <EditableTableCell
//                       record={record}
//                       field="notes"
//                       value={editingId === record.id ? editedRowData?.notes : record.notes}
//                       isEditing={editingId === record.id}
//                       onFieldChange={handleFieldChange}
//                       fieldType="text"
//                     />
                    
//                     <TableCell>{record.park_id}</TableCell>
                    
//                     <TableCell>
//                       {editingId === record.id ? (
//                         <Select
//                           size="small"
//                           value={editedRowData?.status || 'pending'}
//                           onChange={(e) => handleFieldChange("status", e.target.value)}
//                           sx={{ width: '120px' }}
//                         >
//                           <MenuItem value="pending">Pending</MenuItem>
//                           <MenuItem value="approved">Verified</MenuItem>
//                           <MenuItem value="declined">Declined</MenuItem>
//                           <MenuItem value="requested">Requested</MenuItem>
//                         </Select>
//                       ) : (
//                         <Chip
//                           label={(record.status || "pending").toUpperCase()}
//                           color={getChipColor(record.status || "pending")}
//                           size="small"
//                           variant="outlined"
//                         />
//                       )}
//                     </TableCell>
                    
//                     <TableCell align="center">
//                       <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
//                         {editingId === record.id ? (
//                           // Show Save and Cancel buttons when in edit mode - Like investorActivity
//                           <>
//                             <IconButton 
//                               size="small" 
//                               color="success"
//                               onClick={handleSaveInlineEdit}
//                               title="Save Changes"
//                               disabled={isProcessing}
//                             >
//                               <SaveIcon fontSize="small" />
//                             </IconButton>
//                             <IconButton 
//                               size="small" 
//                               color="error"
//                               onClick={handleCancelInlineEdit}
//                               title="Cancel Edit"
//                               disabled={isProcessing}
//                             >
//                               <CancelIcon fontSize="small" />
//                             </IconButton>
//                           </>
//                         ) : (
//                           // Show regular action buttons when not in edit mode - Like investorActivity
//                           <>
//                             <IconButton 
//                               size="small" 
//                               color="info"
//                               onClick={() => handleViewRecord(record)}
//                               title="View Details"
//                             >
//                               <ViewIcon fontSize="small" />
//                             </IconButton>
//                             <IconButton 
//                               size="small" 
//                               color="primary"
//                               onClick={() => handleInlineEdit(record)}
//                               title="Edit"
//                               disabled={record.status === "approved" || record.status === "declined"}
//                             >
//                               <EditIcon fontSize="small" />
//                             </IconButton>
                           
//                             <IconButton 
//                               size="small" 
//                               onClick={(e) => handleActionMenuOpen(e, record)}
//                               title="More Actions"
//                               disabled={record.status === "approved" || record.status === "declined"}
//                             >
//                               <MoreVertIcon fontSize="small" />
//                             </IconButton>
//                           </>
//                         )}
//                       </Box>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25]}
//           component="div"
//           count={totalRecords}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </Paper>

//       {/* View Record Dialog - Similar to investorActivity */}
//       <Dialog 
//         open={viewDialogOpen} 
//         onClose={handleCloseViewDialog}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           Handover Record Details
//           {selectedRow && (
//             <Chip 
//               label={`ID: ${selectedRow.id}`} 
//               size="small" 
//               color="primary"
//               sx={{ ml: 2 }}
//             />
//           )}
//         </DialogTitle>
//         <DialogContent dividers>
//           {selectedRow && (
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <Typography variant="subtitle2" color="textSecondary">No</Typography>
//                 <Typography variant="body1">{selectedRow.no}</Typography>
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <Typography variant="subtitle2" color="textSecondary">ID</Typography>
//                 <Typography variant="body1">{selectedRow.id}</Typography>
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <Typography variant="subtitle2" color="textSecondary">Agreement ID</Typography>
//                 <Typography variant="body1">{selectedRow.agreement_id}</Typography>
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="textSecondary">Handed Over To</Typography>
//                 <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="textSecondary">Handed Over By</Typography>
//                 <Typography variant="body1">{selectedRow.handed_over_by}</Typography>
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="textSecondary">Handover Date</Typography>
//                 <Typography variant="body1">
//                   {selectedRow.date_of_handover_formatted || "N/A"}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="textSecondary">Park ID</Typography>
//                 <Typography variant="body1">{selectedRow.park_id}</Typography>
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="textSecondary">Status</Typography>
//                 <Chip 
//                   label={(selectedRow.status || "pending").toUpperCase()} 
//                   color={getChipColor(selectedRow.status || "pending")}
//                   size="small"
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <Typography variant="subtitle2" color="textSecondary">Notes</Typography>
//                 <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                   {selectedRow.notes || 'No notes provided'}
//                 </Typography>
//               </Grid>
              
//               {selectedRow.remarks && (
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" color="textSecondary">Remarks</Typography>
//                   <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                     {selectedRow.remarks}
//                   </Typography>
//                 </Grid>
//               )}
              
//               <Grid item xs={12}>
//                 <Divider sx={{ my: 1 }} />
//                 <Typography variant="caption" color="textSecondary">
//                   Created: {selectedRow.created_at ? new Date(selectedRow.created_at).toLocaleString() : 'N/A'}
//                   {selectedRow.updated_at && ` | Last Updated: ${new Date(selectedRow.updated_at).toLocaleString()}`}
//                 </Typography>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseViewDialog}>Close</Button>
//           {selectedRow && (
//             <Button 
//               variant="contained" 
//               onClick={() => {
//                 handleInlineEdit(selectedRow);
//                 handleCloseViewDialog();
//                 showInfoToast("Loading record for editing...");
//               }}
//               disabled={selectedRow.status === "approved" || selectedRow.status === "declined"}
//             >
//               Edit Record
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>

//       {/* Approval Dialog */}
//       <Dialog open={approvalDialogOpen} onClose={() => setApprovalDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <CheckCircleIcon sx={{ color: 'success.main' }} />
//             <Typography>Approve Handover</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedRow && (
//             <Box sx={{ mb: 3 }}>
//               <Typography variant="subtitle2" color="textSecondary">Agreement ID:</Typography>
//               <Typography variant="body1" fontWeight="medium">{selectedRow.agreement_id}</Typography>
              
//               <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 1 }}>
//                 Handed Over To:
//               </Typography>
//               <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
//             </Box>
//           )}
          
//           <Typography sx={{ mb: 2 }}>
//             Are you sure you want to verify this handover record?
//           </Typography>
          
//           <TextField
//             label="Remarks (Optional)"
//             fullWidth
//             multiline
//             rows={3}
//             value={remarks}
//             onChange={(e) => setRemarks(e.target.value)}
//             placeholder="Add any remarks or comments..."
//             variant="outlined"
//             sx={{ mt: 2 }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setApprovalDialogOpen(false)} disabled={isProcessing}>
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleVerifyConfirm} 
//             variant="contained" 
//             sx={{ 
//               minWidth: 120,
//               backgroundColor: '#4caf50',
//               '&:hover': { backgroundColor: '#388e3c' }
//             }}
//             startIcon={<CheckCircleIcon />}
//             disabled={isProcessing}
//           >
//             {isProcessing ? <CircularProgress size={24} /> : "Verify"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Decline Dialog */}
//       <Dialog open={declineDialogOpen} onClose={() => setDeclineDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <CancelIcon sx={{ color: 'error.main' }} />
//             <Typography>Decline Handover</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedRow && (
//             <Box sx={{ mb: 3 }}>
//               <Typography variant="subtitle2" color="textSecondary">Agreement ID:</Typography>
//               <Typography variant="body1" fontWeight="medium">{selectedRow.agreement_id}</Typography>
              
//               <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 1 }}>
//                 Handed Over To:
//               </Typography>
//               <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
//             </Box>
//           )}
          
//           <Typography sx={{ mb: 2 }}>
//             Are you sure you want to decline this handover record?
//           </Typography>
          
//           <TextField
//             label="Reason for Decline"
//             fullWidth
//             multiline
//             rows={3}
//             value={remarks}
//             onChange={(e) => setRemarks(e.target.value)}
//             placeholder="Please provide reason for declining..."
//             required
//             variant="outlined"
//             sx={{ mt: 2 }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setDeclineDialogOpen(false)} disabled={isProcessing}>
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDeclineConfirm} 
//             variant="contained" 
//             sx={{ 
//               minWidth: 120,
//               backgroundColor: '#f44336',
//               '&:hover': { backgroundColor: '#d32f2f' }
//             }}
//             startIcon={<CancelIcon />}
//             disabled={isProcessing || !remarks.trim()}
//           >
//             {isProcessing ? <CircularProgress size={24} /> : "Decline"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Request More Info Dialog */}
//       <Dialog open={requestDialogOpen} onClose={() => setRequestDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <InfoIcon sx={{ color: 'warning.main' }} />
//             <Typography>Request More Information</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedRow && (
//             <Box sx={{ mb: 3 }}>
//               <Typography variant="subtitle2" color="textSecondary">Agreement ID:</Typography>
//               <Typography variant="body1" fontWeight="medium">{selectedRow.agreement_id}</Typography>
              
//               <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 1 }}>
//                 Handed Over To:
//               </Typography>
//               <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
//             </Box>
//           )}
          
//           <Typography sx={{ mb: 2 }}>
//             What additional information do you need?
//           </Typography>
          
//           <TextField
//             label="Request Details"
//             fullWidth
//             multiline
//             rows={4}
//             value={remarks}
//             onChange={(e) => setRemarks(e.target.value)}
//             placeholder="Specify what additional information or documents are needed..."
//             required
//             variant="outlined"
//             sx={{ mt: 2 }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setRequestDialogOpen(false)} disabled={isProcessing}>
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleRequestConfirm} 
//             variant="contained" 
//             sx={{ 
//               minWidth: 140,
//               backgroundColor: '#ff9800',
//               '&:hover': { backgroundColor: '#f57c00' }
//             }}
//             startIcon={<InfoIcon />}
//             disabled={isProcessing || !remarks.trim()}
//           >
//             {isProcessing ? <CircularProgress size={24} /> : "Send Request"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// }
import React, { useEffect, useState } from "react";
import { 
  GetDataFromApiWithParams,
  UpdateAndGetResponse,
  DeleteAndGetResponse
} from "../../../../services/api/ExecuteApiRequests";
import { 
  Box, 
  Button, 
  IconButton, 
  Menu, 
  MenuItem, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  TextField,
  Typography,
  Chip,
  CircularProgress,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  Avatar,
  Badge,
  Snackbar,
  Container,
  Divider
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { 
  Search as SearchIcon,
  FilterList as FilterListIcon,
  MoreVert as MoreVertIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Clear as ClearIcon,
  Download as DownloadIcon,
  PictureAsPdf as PdfIcon,
  InsertDriveFile as FileIcon,
  Visibility as ViewIcon,
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon
} from "@mui/icons-material";
import useDecodedUser from "../../../../services/hooks/useDecodedUser";

// Simple Alert component
const Alert = MuiAlert;

// EditableTableCell component for inline editing
const EditableTableCell = ({ record, field, value, isEditing, onFieldChange, fieldType = "text" }) => {
  if (isEditing) {
    // For date fields
    if (fieldType === "date") {
      return (
        <TableCell>
          <TextField
            size="small"
            type="date"
            value={value ? new Date(value).toISOString().split('T')[0] : ''}
            onChange={(e) => onFieldChange(field, e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: '100%' }}
          />
        </TableCell>
      );
    }
    
    // For numeric fields
    if (fieldType === "number") {
      return (
        <TableCell>
          <TextField
            size="small"
            type="number"
            value={value || 0}
            onChange={(e) => onFieldChange(field, parseInt(e.target.value) || 0)}
            sx={{ width: '80px' }}
            inputProps={{ min: 0 }}
          />
        </TableCell>
      );
    }
    
    // For text fields
    if (fieldType === "text") {
      return (
        <TableCell>
          <TextField
            size="small"
            value={value || ''}
            onChange={(e) => onFieldChange(field, e.target.value)}
            sx={{ width: '100%' }}
            multiline={field === "description" || field === "notes"}
            rows={field === "description" || field === "notes" ? 2 : 1}
          />
        </TableCell>
      );
    }
    
    // For status field (select)
    if (fieldType === "status") {
      return (
        <TableCell>
          <Select
            size="small"
            value={value || 'pending'}
            onChange={(e) => onFieldChange(field, e.target.value)}
            sx={{ width: '120px' }}
          >
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="verified">Verified</MenuItem>
            <MenuItem value="declined">Declined</MenuItem>
            <MenuItem value="requested">Requested</MenuItem>
          </Select>
        </TableCell>
      );
    }
    
    // Default to regular cell for non-editable fields
    return <TableCell>{value}</TableCell>;
  }
  
  // Non-editable mode - display values
  if (fieldType === "date" && value) {
    return <TableCell>{new Date(value).toLocaleDateString()}</TableCell>;
  }
  
  if (fieldType === "number") {
    return <TableCell>{value || 0}</TableCell>;
  }
  
  return <TableCell>{value || ''}</TableCell>;
};

export default function ApproveHandover() {
  // Main states
  const [handoverData, setHandoverData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Search and filter states
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  
  // Status filter states
  const [statusFilter, setStatusFilter] = useState("all");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  
  // Row selection and action states
  const [selectedRow, setSelectedRow] = useState(null);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  
  // Dialog states
  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [declineDialogOpen, setDeclineDialogOpen] = useState(false);
  const [requestDialogOpen, setRequestDialogOpen] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  
  // Processing states
  const [isProcessing, setIsProcessing] = useState(false);
  
  // Inline editing states
  const [editingId, setEditingId] = useState(null);
  const [editedRowData, setEditedRowData] = useState(null);
  const [originalRowData, setOriginalRowData] = useState(null);
  
  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  
  // Toast Notification States
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");

  const decodedUser = useDecodedUser();

  // Toast Notification Functions
  const showToast = (message, severity = "success") => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToastOpen(false);
  };

  const showSuccessToast = (message) => {
    showToast(message, "success");
  };

  const showErrorToast = (message) => {
    showToast(message, "error");
  };

  const showWarningToast = (message) => {
    showToast(message, "warning");
  };

  const showInfoToast = (message) => {
    showToast(message, "info");
  };

  // Get status color
  const getStatusColor = (status) => {
    switch(status?.toLowerCase()) {
      case "verified": return "success";
      case "declined": return "error";
      case "pending": return "warning";
      case "requested": return "info";
      default: return "default";
    }
  };

  // Get chip color
  const getChipColor = (status) => {
    switch(status?.toLowerCase()) {
      case "verified": return "success";
      case "declined": return "error";
      case "pending": return "warning";
      case "requested": return "info";
      default: return "default";
    }
  };

  // Fetch handover data with API call like code 2
  const fetchHandoverData = async () => {
    setLoading(true);
    try {
      const response = await GetDataFromApiWithParams("/parks/handover");
      
      if (response && Array.isArray(response)) {
        console.log("Handover data fetched:", response);
        
        // Format dates for display
        const formattedData = response.map((item, index) => ({
          ...item,
          no: index + 1, // Add sequential number
          date_of_handover_formatted: item.date_of_handover 
            ? new Date(item.date_of_handover).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })
            : "N/A",
          original_date_of_handover: item.date_of_handover,
          status: item.status || "pending"
        }));
        
        setHandoverData(formattedData);
        setSearchResults(formattedData);
        setTotalRecords(formattedData.length);
        
        showSuccessToast("Handover records loaded successfully!");
      } else {
        setHandoverData([]);
        setSearchResults([]);
        setTotalRecords(0);
        showInfoToast("No handover records found");
      }
    } catch (error) {
      console.error("Error fetching handover data:", error);
      setHandoverData([]);
      setSearchResults([]);
      setTotalRecords(0);
      showErrorToast("Failed to load handover records");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHandoverData();
  }, []);

  // Search function for edit tab - with API call
  const handleSearch = async () => {
    try {
      setIsSearching(true);
      
      const searchValue = searchQuery.toLowerCase().trim();
      
      if (!searchValue) {
        // If search is empty, fetch all records
        await fetchHandoverData();
        return;
      }
      
      // API search call - adjust endpoint as needed
      const response = await GetDataFromApiWithParams("parks/searchhandover", [searchValue]);
      
      if (response && Array.isArray(response)) {
        const formattedData = response.map((item, index) => ({
          ...item,
          no: index + 1,
          date_of_handover_formatted: item.date_of_handover 
            ? new Date(item.date_of_handover).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })
            : "N/A",
          original_date_of_handover: item.date_of_handover,
          status: item.status || "pending"
        }));
        
        setSearchResults(formattedData);
        setTotalRecords(formattedData.length);
        setPage(0);
        
        const resultCount = formattedData.length;
        if (resultCount > 0) {
          showSuccessToast(`Found ${resultCount} handover records!`);
        } else {
          showWarningToast("No records found for your search.");
        }
      } else {
        setSearchResults([]);
        setTotalRecords(0);
        showWarningToast("No records found for your search.");
      }
    } catch (error) {
      console.error("Error searching handovers:", error);
      setSearchResults([]);
      setTotalRecords(0);
      showErrorToast("Search failed! Please try again.");
    } finally {
      setIsSearching(false);
    }
  };

  // Handle enter key in search
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // Apply status filters
  const applyStatusFilter = (status) => {
    setStatusFilter(status);
    let filtered = [...handoverData];
    
    if (status !== "all") {
      filtered = filtered.filter(item => 
        (item.status || "pending").toLowerCase() === status.toLowerCase()
      );
    }
    
    // Also apply search query if exists
    if (searchQuery.trim()) {
      const searchValue = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(item => 
        (item.id && item.id.toString().toLowerCase().includes(searchValue)) ||
        (item.agreement_id && item.agreement_id.toLowerCase().includes(searchValue)) ||
        (item.handed_over_to && item.handed_over_to.toLowerCase().includes(searchValue)) ||
        (item.handed_over_by && item.handed_over_by.toLowerCase().includes(searchValue)) ||
        (item.notes && item.notes.toLowerCase().includes(searchValue)) ||
        (item.park_id && item.park_id.toLowerCase().includes(searchValue))
      );
    }
    
    setSearchResults(filtered);
    setTotalRecords(filtered.length);
    setPage(0);
    setFilterAnchorEl(null);
  };

  // Clear all filters
  const handleClearFilters = () => {
    setSearchQuery("");
    setStatusFilter("all");
    fetchHandoverData();
    showInfoToast("All filters cleared");
  };

  // Start inline editing
  const handleInlineEdit = (record) => {
    // If we're already editing a different row, cancel that edit first
    if (editingId && editingId !== record.id) {
      handleCancelInlineEdit();
    }
    
    setEditingId(record.id);
    setOriginalRowData({...record});
    setEditedRowData({...record});
    
    showInfoToast(`Editing record #${record.id}. Click save to save changes or cancel to discard.`);
  };

  // Save inline edits - with API call like code 2
  const handleSaveInlineEdit = async () => {
    if (!editedRowData) return;
    
    try {
      setIsProcessing(true);
      showInfoToast("Saving changes...");
      
      // Prepare the data for update - like code 2
      const updateData = {
        ...editedRowData,
        date_of_handover: editedRowData.original_date_of_handover || editedRowData.date_of_handover,
        // Remove formatted fields
        date_of_handover_formatted: undefined,
        no: undefined
      };
      
      console.log("Sending data to update:", updateData);
      console.log("Updating record ID:", editingId);
      
      // API call like code 2
      const result = await UpdateAndGetResponse(`parks/handover/${editingId}`, updateData);
      
      if (result) {
        // Update local state
        setHandoverData(prevData =>
          prevData.map(item =>
            item.id === editingId
              ? { 
                  ...result,
                  date_of_handover_formatted: result.date_of_handover 
                    ? new Date(result.date_of_handover).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })
                    : "N/A",
                  no: item.no
                }
              : item
          )
        );
        
        // Update search results
        setSearchResults(prevResults => 
          prevResults.map(item =>
            item.id === editingId
              ? { 
                  ...result,
                  date_of_handover_formatted: result.date_of_handover 
                    ? new Date(result.date_of_handover).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })
                    : "N/A",
                  no: item.no
                }
              : item
          )
        );
        
        // Exit edit mode
        setEditingId(null);
        setEditedRowData(null);
        setOriginalRowData(null);
        
        showSuccessToast("Record updated successfully!");
      }
    } catch (error) {
      console.error("Error saving record:", error);
      showErrorToast("Failed to save changes!");
    } finally {
      setIsProcessing(false);
    }
  };

  // Cancel inline editing
  const handleCancelInlineEdit = () => {
    setEditingId(null);
    setEditedRowData(null);
    setOriginalRowData(null);
    showInfoToast("Edit cancelled");
  };

  // Handle field changes in inline editing
  const handleFieldChange = (fieldName, value) => {
    setEditedRowData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  // Delete record - with API call like code 2
  const handleDeleteRecord = async (recordId) => {
    if (window.confirm("Are you sure you want to delete this handover record?")) {
      try {
        setIsProcessing(true);
        showInfoToast("Deleting handover record...");
        
        // API call like code 2
        await DeleteAndGetResponse(`parks/handover/${recordId}`);
        
        // Update local state
        setHandoverData(prevData => prevData.filter(item => item.id !== recordId));
        setSearchResults(prevData => prevData.filter(item => item.id !== recordId));
        setTotalRecords(prev => prev - 1);
        
        // If we're deleting the record that's being edited, cancel edit mode
        if (editingId === recordId) {
          setEditingId(null);
          setEditedRowData(null);
          setOriginalRowData(null);
        }
        
        showSuccessToast("Handover record deleted successfully!");
      } catch (error) {
        console.error("Error deleting record:", error);
        showErrorToast("Failed to delete handover record!");
      } finally {
        setIsProcessing(false);
      }
    }
  };

  // View record details
  const handleViewRecord = (record) => {
    setSelectedRow(record);
    setViewDialogOpen(true);
    showInfoToast(`Viewing details for record #${record.id}`);
  };

  const handleCloseViewDialog = () => {
    setViewDialogOpen(false);
    setSelectedRow(null);
  };

  // Action menu handlers - FIXED: Don't clear selectedRow here
  const handleActionMenuOpen = (event, row) => {
    setActionMenuAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
    // DON'T setSelectedRow(null) here - we need it for the dialog
  };

  // Action handlers for MoreVert menu
  const handleApproveClick = () => {
    setApprovalDialogOpen(true);
    handleActionMenuClose();
  };

  const handleDeclineClick = () => {
    setDeclineDialogOpen(true);
    handleActionMenuClose();
  };

  const handleRequestClick = () => {
    setRequestDialogOpen(true);
    handleActionMenuClose();
  };

  const handleViewDetails = (row) => {
    handleViewRecord(row);
    handleActionMenuClose();
  };

  // API call to update status - with actual API call
  const updateHandoverStatus = async (handoverId, newStatus, remarks = "") => {
    
    setIsProcessing(true);
    try {
      // API call like code 2
      const updateData = {
        status: newStatus,
        remarks: remarks,
        id: handoverId
      };
      
      const result = await UpdateAndGetResponse(`parks/updatehandover/${handoverId}`, updateData);
      
      if (result) {
        // Update local state
        setHandoverData(prevData =>
          prevData.map(item =>
            item.id === handoverId
              ? { 
                  ...item, 
                  ...result
                }
              : item
          )
        );
        
        // Update search results
        setSearchResults(prevResults => 
          prevResults.map(item =>
            item.id === handoverId
              ? { 
                  ...item, 
                  ...result
                }
              : item
          )
        );
        
        showSuccessToast(`Handover ${newStatus} successfully!`);
        return true;
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showErrorToast(`Failed to ${newStatus} handover`);
      return false;
    } finally {
      setIsProcessing(false);
    }
  };

  // Dialog handlers - FIXED: Clear selectedRow after action
  const handleVerifyConfirm = async () => {
    if (!selectedRow) {
      showErrorToast("No record selected!");
      setApprovalDialogOpen(false);
      return;
    }
       
    const success = await updateHandoverStatus(selectedRow.id, "verified", remarks);
    if (success) {
      setApprovalDialogOpen(false);
      setRemarks("");
      setSelectedRow(null); // Clear AFTER the action is done
      handleRefreshActivities();
    }
  };

  const handleDeclineConfirm = async () => {
    if (!selectedRow) {
      showErrorToast("No record selected!");
      setDeclineDialogOpen(false);
      return;
    }
    
    const success = await updateHandoverStatus(selectedRow.id, "declined", remarks);
    if (success) {
      setDeclineDialogOpen(false);
      setRemarks("");
      setSelectedRow(null); // Clear AFTER the action is done
    }
  };

  const handleRequestConfirm = async () => {
    if (!selectedRow) {
      showErrorToast("No record selected!");
      setRequestDialogOpen(false);
      return;
    }
    
    const success = await updateHandoverStatus(selectedRow.id, "requested", remarks);
    if (success) {
      setRequestDialogOpen(false);
      setRemarks("");
      setSelectedRow(null); // Clear AFTER the action is done
    }
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Refresh activities list
  const handleRefreshActivities = () => {
    fetchHandoverData();
    showInfoToast("Refreshing handover records...");
  };

  // Calculate paginated data
  const paginatedData = searchResults.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Container>
      {/* Toast Notification */}
      <Snackbar 
        open={toastOpen} 
        autoHideDuration={6000} 
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleToastClose} 
          severity={toastSeverity}
          sx={{ width: '100%' }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>

      {/* Main Title */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Handover Approvals
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Review and verify handover records
        </Typography>
      </Box>
          
      {/* Search Section */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Search by ID, Agreement ID, Handover To, Notes, etc."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={handleSearchKeyPress}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} />,
              }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleSearch}
              disabled={isSearching || loading}
              startIcon={<SearchIcon />}
            >
              {isSearching ? 'Searching...' : 'Search'}
            </Button>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleRefreshActivities}
              startIcon={<RefreshIcon />}
              disabled={loading}
            >
              Refresh
            </Button>
          </Grid>
        </Grid>
        
        {/* Filter chips and status */}
        <Box sx={{ mt: 2, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
          <Button
            size="small"
            startIcon={<FilterListIcon />}
            onClick={(e) => setFilterAnchorEl(e.currentTarget)}
            variant={statusFilter !== "all" ? "contained" : "outlined"}
            color="primary"
          >
            Status Filter
          </Button>
          
          {statusFilter !== "all" && (
            <Chip
              label={`Status: ${statusFilter}`}
              onDelete={() => applyStatusFilter("all")}
              size="small"
              color="primary"
            />
          )}
          
          {(searchQuery || statusFilter !== "all") && (
            <Button
              size="small"
              startIcon={<ClearIcon />}
              onClick={handleClearFilters}
              variant="outlined"
            >
              Clear Filters
            </Button>
          )}
        </Box>
      </Paper>

      {/* Status filter menu */}
      <Menu
        anchorEl={filterAnchorEl}
        open={Boolean(filterAnchorEl)}
        onClose={() => setFilterAnchorEl(null)}
      >
        <MenuItem onClick={() => applyStatusFilter("all")}>
          All Status
        </MenuItem>
        <MenuItem onClick={() => applyStatusFilter("pending")}>
          <Chip label="PENDING" color="warning" size="small" sx={{ mr: 1 }} />
          Pending
        </MenuItem>
        <MenuItem onClick={() => applyStatusFilter("verified")}>
          <Chip label="VERIFIED" color="success" size="small" sx={{ mr: 1 }} />
          Verified
        </MenuItem>
        <MenuItem onClick={() => applyStatusFilter("declined")}>
          <Chip label="DECLINED" color="error" size="small" sx={{ mr: 1 }} />
          Declined
        </MenuItem>
        <MenuItem onClick={() => applyStatusFilter("requested")}>
          <Chip label="REQUESTED" color="info" size="small" sx={{ mr: 1 }} />
          Requested
        </MenuItem>
      </Menu>

      {/* Action menu */}
      <Menu
        anchorEl={actionMenuAnchorEl}
        open={Boolean(actionMenuAnchorEl)}
        onClose={handleActionMenuClose}
      >
        <MenuItem onClick={() => handleViewDetails(selectedRow)}>
          <ViewIcon sx={{ mr: 1, fontSize: 20 }} />
          View Details
        </MenuItem>
        <MenuItem onClick={handleApproveClick} disabled={selectedRow?.status === "verified"}>
          <CheckCircleIcon sx={{ mr: 1, fontSize: 20, color: 'success.main' }} />
          Verify
        </MenuItem>
        <MenuItem onClick={handleDeclineClick} disabled={selectedRow?.status === "declined"}>
          <CancelIcon sx={{ mr: 1, fontSize: 20, color: 'error.main' }} />
          Decline
        </MenuItem>
        
      </Menu>

      {/* Results Section */}
      <Paper sx={{ width: '100%', overflow: 'hidden', mb: 3 }}>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Agreement ID</TableCell>
                <TableCell>Handed Over To</TableCell>
                <TableCell>Handed Over By</TableCell>
                <TableCell>Handover Date</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell>Park ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Loading handover records...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : searchResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Typography variant="body2" color="textSecondary">
                      {searchQuery || statusFilter !== "all" 
                        ? 'No records found for your search criteria. Try a different search term.' 
                        : 'No handover records found. Start by registering handovers.'}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((record) => (
                  <TableRow 
                    key={record.id} 
                    hover
                    sx={{ 
                      backgroundColor: editingId === record.id ? 'action.selected' : 'inherit',
                      '&:hover': {
                        backgroundColor: editingId === record.id ? 'action.selected' : 'action.hover'
                      }
                    }}
                  >
                    <TableCell>{record.no}</TableCell>
                    <TableCell>{record.id}</TableCell>
                    
                    {/* Editable cells */}
                    <EditableTableCell
                      record={record}
                      field="agreement_id"
                      value={editingId === record.id ? editedRowData?.agreement_id : record.agreement_id}
                      isEditing={editingId === record.id}
                      onFieldChange={handleFieldChange}
                      fieldType="text"
                    />
                    
                    <EditableTableCell
                      record={record}
                      field="handed_over_to"
                      value={editingId === record.id ? editedRowData?.handed_over_to : record.handed_over_to}
                      isEditing={editingId === record.id}
                      onFieldChange={handleFieldChange}
                      fieldType="text"
                    />
                    
                    <EditableTableCell
                      record={record}
                      field="handed_over_by"
                      value={editingId === record.id ? editedRowData?.handed_over_by : record.handed_over_by}
                      isEditing={editingId === record.id}
                      onFieldChange={handleFieldChange}
                      fieldType="text"
                    />
                    
                    <EditableTableCell
                      record={record}
                      field="date_of_handover"
                      value={editingId === record.id ? editedRowData?.original_date_of_handover : record.original_date_of_handover}
                      isEditing={editingId === record.id}
                      onFieldChange={handleFieldChange}
                      fieldType="date"
                    />
                    
                    <EditableTableCell
                      record={record}
                      field="notes"
                      value={editingId === record.id ? editedRowData?.notes : record.notes}
                      isEditing={editingId === record.id}
                      onFieldChange={handleFieldChange}
                      fieldType="text"
                    />
                    
                    <TableCell>{record.park_id}</TableCell>
                    
                    <TableCell>
                      {editingId === record.id ? (
                        <Select
                          size="small"
                          value={editedRowData?.status || 'pending'}
                          onChange={(e) => handleFieldChange("status", e.target.value)}
                          sx={{ width: '120px' }}
                        >
                          <MenuItem value="pending">Pending</MenuItem>
                          <MenuItem value="verified">Verified</MenuItem>
                          <MenuItem value="declined">Declined</MenuItem>
                          <MenuItem value="requested">Requested</MenuItem>
                        </Select>
                      ) : (
                        <Chip
                          label={(record.status || "pending").toUpperCase()}
                          color={getChipColor(record.status || "pending")}
                          size="small"
                          variant="outlined"
                        />
                      )}
                    </TableCell>
                    
                    <TableCell align="center">
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
                        {editingId === record.id ? (
                          // Show Save and Cancel buttons when in edit mode
                          <>
                            <IconButton 
                              size="small" 
                              color="success"
                              onClick={handleSaveInlineEdit}
                              title="Save Changes"
                              disabled={isProcessing}
                            >
                              <SaveIcon fontSize="small" />
                            </IconButton>
                            <IconButton 
                              size="small" 
                              color="error"
                              onClick={handleCancelInlineEdit}
                              title="Cancel Edit"
                              disabled={isProcessing}
                            >
                              <CancelIcon fontSize="small" />
                            </IconButton>
                          </>
                        ) : (
                          // Show regular action buttons when not in edit mode
                          <>
                            <IconButton 
                              size="small" 
                              color="info"
                              onClick={() => handleViewRecord(record)}
                              title="View Details"
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                            <IconButton 
                              size="small" 
                              color="primary"
                              onClick={() => handleInlineEdit(record)}
                              title="Edit"
                              disabled={record.status === "verified" || record.status === "declined" || record.status === "requested"}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                           
                            <IconButton 
                              size="small" 
                              onClick={(e) => handleActionMenuOpen(e, record)}
                              title="More Actions"
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRecords}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* View Record Dialog */}
      <Dialog 
        open={viewDialogOpen} 
        onClose={handleCloseViewDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Handover Record Details
          {selectedRow && (
            <Chip 
              label={`ID: ${selectedRow.id}`} 
              size="small" 
              color="primary"
              sx={{ ml: 2 }}
            />
          )}
        </DialogTitle>
        <DialogContent dividers>
          {selectedRow && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">No</Typography>
                <Typography variant="body1">{selectedRow.no}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">ID</Typography>
                <Typography variant="body1">{selectedRow.id}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">Agreement ID</Typography>
                <Typography variant="body1">{selectedRow.agreement_id}</Typography>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">Handed Over To</Typography>
                <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">Handed Over By</Typography>
                <Typography variant="body1">{selectedRow.handed_over_by}</Typography>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">Handover Date</Typography>
                <Typography variant="body1">
                  {selectedRow.date_of_handover_formatted || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">Park ID</Typography>
                <Typography variant="body1">{selectedRow.park_id}</Typography>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                <Chip 
                  label={(selectedRow.status || "pending").toUpperCase()} 
                  color={getChipColor(selectedRow.status || "pending")}
                  size="small"
                />
              </Grid>
              
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">Notes</Typography>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                  {selectedRow.notes || 'No notes provided'}
                </Typography>
              </Grid>
              
              {selectedRow.remarks && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">Remarks</Typography>
                  <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                    {selectedRow.remarks}
                  </Typography>
                </Grid>
              )}
              
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
                <Typography variant="caption" color="textSecondary">
                  Created: {selectedRow.created_at ? new Date(selectedRow.created_at).toLocaleString() : 'N/A'}
                  {selectedRow.updated_at && ` | Last Updated: ${new Date(selectedRow.updated_at).toLocaleString()}`}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewDialog}>Close</Button>
          {selectedRow && (
            <Button 
              variant="contained" 
              onClick={() => {
                handleInlineEdit(selectedRow);
                handleCloseViewDialog();
                showInfoToast("Loading record for editing...");
              }}
              disabled={selectedRow.status === "verified" || selectedRow.status === "declined" || selectedRow.status === "requested"}
            >
              Edit Record
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Verify Dialog - FIXED: Clear selectedRow on close */}
      <Dialog 
        open={approvalDialogOpen} 
        onClose={() => {
          setApprovalDialogOpen(false);
          setSelectedRow(null);
          setRemarks("");
        }} 
        maxWidth="sm" 
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CheckCircleIcon sx={{ color: 'success.main' }} />
            <Typography>Verify Handover</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRow && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" color="textSecondary">Agreement ID:</Typography>
              <Typography variant="body1" fontWeight="medium">{selectedRow.agreement_id}</Typography>
              
              <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 1 }}>
                Handed Over To:
              </Typography>
              <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
            </Box>
          )}
          
          <Typography sx={{ mb: 2 }}>
            Are you sure you want to verify this handover record?
          </Typography>
          
          <TextField
            label="Remarks (Optional)"
            fullWidth
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Add any remarks or comments..."
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button 
            onClick={() => {
              setApprovalDialogOpen(false);
              setSelectedRow(null);
              setRemarks("");
            }} 
            disabled={isProcessing}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleVerifyConfirm} 
            variant="contained" 
            sx={{ 
              minWidth: 120,
              backgroundColor: '#4caf50',
              '&:hover': { backgroundColor: '#388e3c' }
            }}
            startIcon={<CheckCircleIcon />}
            disabled={isProcessing}
          >
            {isProcessing ? <CircularProgress size={24} /> : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Decline Dialog - FIXED: Clear selectedRow on close */}
      <Dialog 
        open={declineDialogOpen} 
        onClose={() => {
          setDeclineDialogOpen(false);
          setSelectedRow(null);
          setRemarks("");
        }} 
        maxWidth="sm" 
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CancelIcon sx={{ color: 'error.main' }} />
            <Typography>Decline Handover</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRow && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" color="textSecondary">Agreement ID:</Typography>
              <Typography variant="body1" fontWeight="medium">{selectedRow.agreement_id}</Typography>
              
              <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 1 }}>
                Handed Over To:
              </Typography>
              <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
            </Box>
          )}
          
          <Typography sx={{ mb: 2 }}>
            Are you sure you want to decline this handover record?
          </Typography>
          
          <TextField
            label="Reason for Decline"
            fullWidth
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Please provide reason for declining..."
            required
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button 
            onClick={() => {
              setDeclineDialogOpen(false);
              setSelectedRow(null);
              setRemarks("");
            }} 
            disabled={isProcessing}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleDeclineConfirm} 
            variant="contained" 
            sx={{ 
              minWidth: 120,
              backgroundColor: '#f44336',
              '&:hover': { backgroundColor: '#d32f2f' }
            }}
            startIcon={<CancelIcon />}
            disabled={isProcessing || !remarks.trim()}
          >
            {isProcessing ? <CircularProgress size={24} /> : "Decline"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Request More Info Dialog - FIXED: Clear selectedRow on close */}
      <Dialog 
        open={requestDialogOpen} 
        onClose={() => {
          setRequestDialogOpen(false);
          setSelectedRow(null);
          setRemarks("");
        }} 
        maxWidth="sm" 
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon sx={{ color: 'warning.main' }} />
            <Typography>Request More Information</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRow && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" color="textSecondary">Agreement ID:</Typography>
              <Typography variant="body1" fontWeight="medium">{selectedRow.agreement_id}</Typography>
              
              <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 1 }}>
                Handed Over To:
              </Typography>
              <Typography variant="body1">{selectedRow.handed_over_to}</Typography>
            </Box>
          )}
          
          <Typography sx={{ mb: 2 }}>
            What additional information do you need?
          </Typography>
          
          <TextField
            label="Request Details"
            fullWidth
            multiline
            rows={4}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Specify what additional information or documents are needed..."
            required
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button 
            onClick={() => {
              setRequestDialogOpen(false);
              setSelectedRow(null);
              setRemarks("");
            }} 
            disabled={isProcessing}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleRequestConfirm} 
            variant="contained" 
            sx={{ 
              minWidth: 140,
              backgroundColor: '#ff9800',
              '&:hover': { backgroundColor: '#f57c00' }
            }}
            startIcon={<InfoIcon />}
            disabled={isProcessing || !remarks.trim()}
          >
            {isProcessing ? <CircularProgress size={24} /> : "Send Request"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}